import getNative from './_getNative';
import root from './_root';

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

export default DataView;



//////////////////
// WEBPACK FOOTER
// ../ckeditor5-utils/src/lib/lodash/_DataView.js
// module id = 331
// module chunks = 0